// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("./Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var LogIO = require("./LogIO.bs.js");
var Axios = require("axios");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Js_Exn = require("relude/src/js/Relude_Js_Exn.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Header = require("./types/CommonTypes_Header.bs.js");
var CommonTypes_StatusCode = require("./types/CommonTypes_StatusCode.bs.js");

function make(data, status, statusText, headers, config) {
  return {
          data: data,
          status: status,
          statusText: statusText,
          headers: headers,
          config: config
        };
}

function decode(json) {
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, make, Curry._3(Json.Decode.optionalField, "data", Json.Decode.ok, json)), Curry._3(Json.Decode.field, "status", CommonTypes_StatusCode.decode, json)), Curry._3(Json.Decode.field, "statusText", Json.Decode.string, json)), Curry._3(Json.Decode.field, "headers", Curry._1(Json.Decode.dict, CommonTypes_Header.decode), json)), Curry._3(Json.Decode.field, "config", Json.Decode.ok, json));
}

function encode(param) {
  return Json.Encode.object_({
              hd: [
                "data",
                Json.Encode.optional(Relude_Globals.id, param.data)
              ],
              tl: {
                hd: [
                  "status",
                  CommonTypes_StatusCode.encode(param.status)
                ],
                tl: {
                  hd: [
                    "statusText",
                    param.statusText
                  ],
                  tl: {
                    hd: [
                      "headers",
                      Js_dict.map(CommonTypes_Header.encode, param.headers)
                    ],
                    tl: {
                      hd: [
                        "config",
                        param.config
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

var $$Response = {
  make: make,
  decode: decode,
  encode: encode
};

function make$1(config, response, code) {
  return {
          config: config,
          response: response,
          code: code
        };
}

function decode$1(json) {
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, make$1, Curry._3(Json.Decode.field, "config", Json.Decode.ok, json)), Curry._3(Json.Decode.field, "response", decode, json)), Curry._3(Json.Decode.optionalField, "code", Json.Decode.string, json));
}

function encode$1(param) {
  return Json.Encode.object_({
              hd: [
                "code",
                Json.Encode.optional((function (prim) {
                        return prim;
                      }), param.code)
              ],
              tl: {
                hd: [
                  "config",
                  param.config
                ],
                tl: {
                  hd: [
                    "response",
                    encode(param.response)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

var ErrorResponse = {
  make: make$1,
  decode: decode$1,
  encode: encode$1
};

function error(param_0) {
  return {
          TAG: /* Error */0,
          _0: param_0
        };
}

function parseError(param_0) {
  return {
          TAG: /* ParseError */1,
          _0: param_0
        };
}

function axiosErrorToJsExn($staropt$star, err) {
  var prefix = $staropt$star !== undefined ? $staropt$star : "";
  if (err.TAG === /* Error */0) {
    return Relude_Js_Exn.make(prefix + err._0.response.statusText);
  } else {
    return Relude_Js_Exn.make(err._0);
  }
}

function axiosResponseToLogIO(lazyAxiosResponse) {
  return LogIO.flatMap(undefined, undefined, undefined, (function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great((function (param) {
                                            return Relude_Globals.$great$great((function (prim) {
                                                          return prim;
                                                        }), decode, param);
                                          }), Json.Decode.mapErrorToDebugString, param);
                            }), (function (msg) {
                              if (msg.TAG === /* Ok */0) {
                                return Curry._1(LogIO.pure, msg._0);
                              } else {
                                return Curry._1(LogIO.$$throw, {
                                            TAG: /* ParseError */1,
                                            _0: msg._0
                                          });
                              }
                            }), param);
              }), LogIO.mapError(undefined, undefined, undefined, (function (param) {
                    return Relude_Globals.$great$great((function (param) {
                                  return Relude_Globals.$great$great((function (param) {
                                                return Relude_Globals.$great$great((function (prim) {
                                                              return prim;
                                                            }), decode$1, param);
                                              }), Json.Decode.mapErrorToDebugString, param);
                                }), (function (msg) {
                                  if (msg.TAG === /* Ok */0) {
                                    return {
                                            TAG: /* Error */0,
                                            _0: msg._0
                                          };
                                  } else {
                                    return {
                                            TAG: /* ParseError */1,
                                            _0: msg._0
                                          };
                                  }
                                }), param);
                  }), LogIO.fromPromiseWithJsExn(lazyAxiosResponse)));
}

function verbToString(verb) {
  switch (verb) {
    case /* Get */0 :
        return "GET";
    case /* Post */1 :
        return "POST";
    case /* Put */2 :
        return "PUT";
    case /* Delete */3 :
        return "DELETE";
    
  }
}

function makeNetworkCall(body, config, verbOpt, url) {
  var verb = verbOpt !== undefined ? verbOpt : /* Get */0;
  return axiosResponseToLogIO(function (param) {
              switch (verb) {
                case /* Get */0 :
                    if (config !== undefined) {
                      return Axios.get(url, Caml_option.valFromOption(config));
                    } else {
                      return Axios.get(url);
                    }
                case /* Post */1 :
                    if (body === undefined) {
                      if (config !== undefined) {
                        return Axios.post(url, {}, Caml_option.valFromOption(config));
                      } else {
                        return Axios.post(url);
                      }
                    }
                    var data = Caml_option.valFromOption(body);
                    if (config !== undefined) {
                      return Axios.post(url, data, Caml_option.valFromOption(config));
                    } else {
                      return Axios.post(url, data);
                    }
                case /* Put */2 :
                    if (body === undefined) {
                      if (config !== undefined) {
                        return Axios.put(url, {}, Caml_option.valFromOption(config));
                      } else {
                        return Axios.put(url);
                      }
                    }
                    var data$1 = Caml_option.valFromOption(body);
                    if (config !== undefined) {
                      return Axios.put(url, data$1, Caml_option.valFromOption(config));
                    } else {
                      return Axios.put(url, data$1);
                    }
                case /* Delete */3 :
                    if (config !== undefined) {
                      return Axios.delete(url, Caml_option.valFromOption(config));
                    } else {
                      return Axios.delete(url);
                    }
                
              }
            });
}

function getDecodedData(decoder) {
  return function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return LogIO.fromOption((function (param) {
                                return {
                                        TAG: /* ParseError */1,
                                        _0: "no data"
                                      };
                              }), param);
                }), (function (param) {
                  return LogIO.flatMap(undefined, undefined, undefined, (function (param) {
                                return Relude_Globals.$great$great((function (param) {
                                              return Relude_Globals.$great$great((function (param) {
                                                            return Relude_Globals.$great$great(decoder, Json.Decode.mapErrorToDebugString, param);
                                                          }), LogIO.fromResult, param);
                                            }), (function (param) {
                                              return LogIO.mapError(undefined, undefined, undefined, parseError, param);
                                            }), param);
                              }), param);
                }), param);
  };
}

function getDecodedData$1(decoder, param) {
  return getDecodedData(decoder)(param.data);
}

function makeNetworkCallAndDecode(body, config, verbOpt, decoder) {
  var verb = verbOpt !== undefined ? verbOpt : /* Get */0;
  var partial_arg = verb;
  var partial_arg$1 = function (param) {
    return makeNetworkCall(body, config, partial_arg, param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$1, (function (param) {
                  return LogIO.flatMap(undefined, undefined, undefined, (function (param) {
                                return getDecodedData$1(decoder, param);
                              }), param);
                }), param);
  };
}

exports.$$Response = $$Response;
exports.ErrorResponse = ErrorResponse;
exports.error = error;
exports.parseError = parseError;
exports.axiosErrorToJsExn = axiosErrorToJsExn;
exports.axiosResponseToLogIO = axiosResponseToLogIO;
exports.verbToString = verbToString;
exports.makeNetworkCall = makeNetworkCall;
exports.getDecodedData = getDecodedData$1;
exports.makeNetworkCallAndDecode = makeNetworkCallAndDecode;
/* Json Not a pure module */
